export function buildFederatedQuery(params: {
  client_id?: string | null;
  state?: string | null;
  code_challenge?: string | null;
  redirect_uri?: string | null;
}) {
  const search = new URLSearchParams();
  if (params.client_id) search.set('client_id', params.client_id);
  if (params.state) search.set('state', params.state);
  if (params.code_challenge) search.set('code_challenge', params.code_challenge);
  if (params.redirect_uri) search.set('redirect_uri', params.redirect_uri);
  const qs = search.toString();
  return qs ? `?${qs}` : '';
}

export function buildAuthCallbackUrl(redirectUri: string, code: string, state: string) {
  const url = new URL(redirectUri);
  url.searchParams.set('code', code);
  url.searchParams.set('state', state);
  return url.toString();
}

export function buildFederatedLoginUrl(params: {
  clientId: string;
  state: string;
  codeChallenge: string;
  redirectUri: string;
}) {
  return `/auth/federated-login${buildFederatedQuery({
    client_id: params.clientId,
    state: params.state,
    code_challenge: params.codeChallenge,
    redirect_uri: params.redirectUri,
  })}`;
}
